import { WalletTemplateDataSource,
         DataType,
         WalletAppleField,
         WalletGoogleField } from './wallet-template-enums';

export class WalletTemplateField {
    public walletTemplateFieldID = 0;
    public walletTemplateID = 0;
    public fieldOrder = 0;
    public dataType = DataType.Unknown;
    public dataSource = WalletTemplateDataSource.None;
    public sourceField = '';
    public label = '';
    public labelDataSource = WalletTemplateDataSource.None;
    public defaultValueDataSource = WalletTemplateDataSource.None;
    public defaultValueSourceField = '';
    public defaultValueLabel = '';
    public defaultValueLabelDataSource = WalletTemplateDataSource.None;
    public appleField = WalletAppleField.Undefined;
    public googleField = WalletGoogleField.Undefined;
    public changeMessage = '';
    public created = new Date();
    public googleClassVariantField = false;

    constructor() {
    }
}
